import React, { useContext, useEffect } from "react";
import { notification, Skeleton } from "antd";
import { Requests } from "./Requests";
import EmptyRequestSvg from "../images/undraw_empty_xct9.svg";
import "../components/accountcenter.css";
import "../components/accountrequest.css";
import { observer } from "mobx-react-lite";
import AccountStore from "../store/accountStore";
import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";

const NoRequest = () => (
	<div className="Aligner">
		<div className="Aligner-item">
			<img
				src={EmptyRequestSvg}
				alt="No Request"
				style={{ maxWidth: "400px" }}
			/>
		</div>
		<div className="Aligner-item Aligner-item--top">No Pending Request!!!</div>
		<div className="Aligner-item Aligner-item--bottom"></div>
	</div>
);

export const AccessControl = observer(() => {
	const accountStore = useContext(AccountStore);

	useEffect(() => {
		async function fetchAllNewAccountRequests() {
			try {
				await accountStore.getAllNewRequests();
				accountStore.isloading = false;
			} catch (error) {
				notification.error({
					message: "SPARS Feedback",
					description: error.message,
				});
			}
		}

		fetchAllNewAccountRequests();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="ms-Grid tabcontainer" dir="ltr">
			<SubPageHeaderTitle
				count={accountStore.accountRequests.size}
				title="New Account Requests"
			/>
			{accountStore.isloading ? (
				<Skeleton active />
			) : accountStore.accountRequests.size === 0 ? (
				<NoRequest />
			) : (
				<Requests requestdata={[...accountStore.accountRequests.values()]} />
			)}
		</div>
	);
});
